<template>
  <div class="ioc-alarm__toolbar">
    <div class="blur-bg map-blur-panel"></div>
    <el-row :gutter="20">
      <el-col class="flex-row valign-center">
        <div v-if="showLevel">
          <div class="ioc-alarm__tips allLevel"
               @click="clickAlarmLevel('')">
            全部:
            <span>
              {{alarmLevelNums.reduce((pre, item) => {
                      return pre+item.number}, 0)}}
            </span>
          </div>
          <div v-for="item in alarmLevelNums"
               :key="item.alarmLevel"
               :class="item.alarmLevel | alarmLevelClass"
               @click="clickAlarmLevel(item.alarmLevel)"
               class="ioc-alarm__tips">
            {{item.alarmLevel | dic('SENU017')}}:
            <span>{{item.number}}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { api } from './api'
import { Dic } from '$utils'
// import regionTree from '@src/components/business/app-area-tree'
export default {
  // components: { regionTree },
  props: {
    innerDoor: {
      type: Boolean,
      default: false
    },
    showLevel: {
      type: Boolean,
      default: true
    },
    showIndoor: {
      type: Boolean,
      default: true
    },
    levelNums: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      isIndoor: false,
      searchDeviceText: '',
      deviceTypes: [
        {
          type: 18,
          typeName: "摄像机",
          img: 'camera',
          isActive: true
        },
        {
          type: 26,
          typeName: "广播设备",
          img: 'broadcastNew',
          isActive: true
        },
        {
          type: -1,
          typeName: "保卫人员",
          img: 'securityNew',
          isActive: true
        },
        {
          type: 25,
          typeName: "道闸",
          img: 'gate',
          isActive: true
        },
        {
          type: 30,
          typeName: "消防车",
          img: 'firetruckNew',
          isActive: true
        }
      ],
      areaId: '',
      deviceList: [],
      areasName: '',
      alarmArea: '',
      alarmLevelNums: []
    }
  },
  computed: {},
  watch: {
    levelNums: {
      handler: function (newVal, oldVal) {
        this.getLevelNums()
      },
      deep: true,
      immediate: true
    }
  },
  created () { },
  mounted () { },
  methods: {
    deviceSearch (deviceString, cb) {
      var deviceList = this.deviceList;
      var results = deviceString ? deviceList.filter(this.createFilter(deviceString)) : deviceList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter (deviceString) {
      return (restaurant) => {
        if (restaurant.value) {
          let aa = (restaurant.value.toLowerCase().indexOf(deviceString.toLowerCase()) !== -1)
          return aa;
        } else {
          return false;
        }
      };
    },
    getLevelNums () {
      this.alarmLevelNums = [];
      let levelNums = this.levelNums || {};
      for (let key in levelNums) {
        this.alarmLevelNums.push({
          alarmLevel: parseInt(key),
          number: levelNums[key]
        })
      }
    },
    clickAlarmLevel (level) {
      this.$emit('levelClick', level)
    },
  }
}
</script>
<style lang="scss">
.ioc-alarm__toolbar {
  .ioc-alarm__area {
    margin: 0 20px 0 10px;
    position: relative;
    width: 300px;
    input {
      padding-right: 60px;
      width: 300px;
      padding-left: 8px;
    }
  }
  .claer-area-btn {
    position: absolute;
    top: 19px;
    color: #ccc;
    right: 40px;
    z-index: 3;
    cursor: pointer;
  }
  .choice-btn {
    position: absolute;
    // color: #0086ff;
    top: 11px;
    right: 5px;
    z-index: 3;
  }
  .device-list {
    .el-autocomplete-suggestion__wrap.el-scrollbar__wrap {
      background-color: #355486;
      border-color: #596f94;
    }
  }
}
</style>



